import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import TermsAndConditions from "@/pages/TermsAndConditions";

export const Route = createFileRoute("/es/terminos-y-condiciones")({
  head: () => buildRouteHead("/es/terminos-y-condiciones"),
  component: TermsAndConditions,
});

